import useUsersAccessRightStore from '@/stores/users/accessRight';

export function workloadToDisplay(workload) { // Convert workload to hours if needed
  const { workloadInHours, workloadHoursPerDay } = useUsersAccessRightStore().config;
  if (! workload || ! workloadInHours) return workload;
  return Math.round(workload * workloadHoursPerDay * 100) / 100;
}

export function workloadToStore(workload) { // Convert workload to days if needed
  const { workloadInHours, workloadHoursPerDay } = useUsersAccessRightStore().config;
  if (! workload || ! workloadInHours) return workload;
  return Math.round(workload / workloadHoursPerDay * 10000) / 10000;
}
